module.exports = __webpack_public_path__ + "static/media/Museo300-Regular.3dff389b.otf";